var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge",class:_vm.rowData.isDeleted ? 'badge-warning' : 'badge-primary'},[_vm._v(" "+_vm._s(_vm.rowData.isDeleted ? 'Deleted' : 'Active')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }